import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  BASIC_AUTH_INTERCEPTOR_CONFIG,
  BasicAuthInterceptorConfigInterface,
} from './basic-auth-interceptor-config.interface';

@Injectable()
/**
 * Intercepts api requests to add basic auth and user accessToken headers
 * Intercepts responses and checks for 401 status and redirects to login
 */
export class BasicAuthInterceptor implements HttpInterceptor {
  constructor(
    @Inject(BASIC_AUTH_INTERCEPTOR_CONFIG) private auth_interceptor_config: BasicAuthInterceptorConfigInterface
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(this.addAuthHeader(req));
  }

  private addAuthHeader(req: HttpRequest<unknown>): HttpRequest<unknown> {
    let headers = {};
    const urlPattern = new RegExp(this.auth_interceptor_config.urlPattern);

    if (this.auth_interceptor_config.urlPattern && urlPattern.test(req.url)) {
      headers = { Authorization: `Basic ${this.auth_interceptor_config.basic_auth}` };
    }
    return req.clone({ setHeaders: headers });
  }
}
